export const LOADING_JOURNALENTRYLINE = "LOADING_JOURNALENTRYLINE";
export const GET_JOURNALENTRYLINE_LIST = "GET_JOURNALENTRYLINE_LIST";
export const ADD_JOURNALENTRYLINE = "ADD_JOURNALENTRYLINE";
export const REMOVE_JOURNALENTRYLINE = "REMOVE_JOURNALENTRYLINE";
export const UPDATE_JOURNALENTRYLINE = "UPDATE_JOURNALENTRYLINE";
export const GET_JOURNALENTRYLINE_ID = "GET_JOURNALENTRYLINE_ID";